export default {
  label: '技术经理',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '兼顾技术与团队管理的角色。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '管理技术团队，分配开发任务，进行代码审核，协调团队资源，提升团队技术水平。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备良好的沟通能力和团队协作能力，能够平衡技术与管理职责。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在10年以上经验后晋升为技术总监或CTO。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪在25,000-50,000元之间，年薪可达50-100万元。',
          id: '0-5-1',
        },
      ],
    },
  ],
};